import { render, staticRenderFns } from "./product-type.component.vue?vue&type=template&id=43a756c4"
import script from "./product-type.component.vue?vue&type=script&lang=js"
export * from "./product-type.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports